import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { useMemo } from "react"
import { SuitePayment } from '@ssc-booking/api-contracts';
import * as Amount from '@ssc-booking/api-contracts/src/amount';
import { Refundability } from "@silversea-ssc/dotcom-read-model-types-fp"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { useReceiptReadModel } from "../../app-core/features/_common/machines/receipt-machine"
import { currentPaymentTerms } from "../../app-core/features/_common/payment-terms"
import { isPresent } from "../../app-core/_common/checks"

type UseDepositResult = {
    depositType: Refundability | undefined
    suitePayment: SuitePayment | undefined
}

export const useDeposit = (): UseDepositResult => {
    const [state] = useECommerceMachine()
    const [stateRC] = useReceiptReadModel(state)

    return useMemo(() => {
        if (!stateRC.matches("present.priceTotal")) return { suitePayment: undefined, depositType: undefined }

        const paymentTerms = currentPaymentTerms(state.context)
        const depositType = F.pipe(
            paymentTerms,
            O.map((x) => x.depositType),
            O.getOrElseW(F.constUndefined),
        )
        const suitePayment = stateRC.context.receipt.suitePayment

        return { suitePayment, depositType }
    }, [state, stateRC])
}

export const isValidPymentTerm = (suitePayment: SuitePayment | undefined): suitePayment is SuitePayment =>
    isPresent(suitePayment?.amount) && Amount.isPositive(suitePayment.amount)

export const isValidDeposit = (suitePayment: SuitePayment | undefined): suitePayment is SuitePayment => {
    return isValidPymentTerm(suitePayment) && suitePayment.type == "deposit"
}
